import fp from 'lodash/fp';
import React, { useCallback, ComponentType } from 'react';
import { formatDateOnlyForBackend } from '@factorin/util';

import { TranslatedCalendarInput } from 'Modules/core/forms';

import { usePaginationFilter, PaginationFilterField } from '../../utils';
import styles from './index.module.scss';


export const PaginationCalendarFilterField: ComponentType<PaginationFilterField> = React.memo(({
    path,
    field,
}) => {
    const mapFromDateToFilter = useCallback(
        (value, filters) => ({
            filters: {
                ...filters,
                [field]: {
                    from: formatDateOnlyForBackend(value),
                    to: fp.get(`${field}.to`, filters),
                },
            },
        }),
        [field],
    );
    const from = usePaginationFilter<Date>(path, field, mapFromDateToFilter, 'from');

    const mapToDateToFilter = useCallback(
        (value, filters) => ({
            filters: {
                ...filters,
                [field]: {
                    from: fp.get(`${field}.from`, filters),
                    to: formatDateOnlyForBackend(value),
                },
            },
        }),
        [field],
    );
    const to = usePaginationFilter<Date>(path, field, mapToDateToFilter, 'to');

    return (
        <div className={styles.calendarContainer}>
            <TranslatedCalendarInput
                className={styles.calendar}
                value={from.value}
                onChange={from.onChange}
            />
            <span className={styles.divider}>-</span>
            <TranslatedCalendarInput
                className={styles.calendar}
                value={to.value}
                onChange={to.onChange}
            />
        </div>
    );
});
